import { Chip, Stack } from '@mui/material';

import Dialog from '@/components/dialog/Dialog';
import useWorkspaceNavigate from '@/hooks/useWorkspaceNavigate';
import { Creator } from '@/models/creator';
import getRoute from '@/utils/getRoute/getRoute';

interface CreatorGroupsModalProps {
  isOpen: boolean;
  onClose: () => void;
  creatorName: string;
  groups: Creator.Groups;
}

const CreatorGroupsModal = ({
  isOpen,
  onClose,
  creatorName,
  groups
}: CreatorGroupsModalProps) => {
  const navigate = useWorkspaceNavigate();

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      title={`Groups for ${creatorName}`}
      showCloseIcon
      maxWidth="xs"
      fullWidth
      dialogContent={
        <Stack direction="row" gap={1} flexWrap="wrap">
          {groups.map(({ id, title }) => (
            <Chip
              key={id}
              label={title}
              onClick={() => {
                navigate(getRoute.creatorGroups.DETAIL(id));
                onClose();
              }}
              sx={{
                cursor: 'pointer',
                transition: 'background-color 0.15s ease, color 0.15s ease',
                '&:hover': {
                  backgroundColor: 'primary.main',
                  color: 'primary.contrastText'
                }
              }}
            />
          ))}
        </Stack>
      }
    />
  );
};

export default CreatorGroupsModal;
